import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import PayrollViewController from "../../redux/actions/payrollApiAction";
import { ClipLoader, FadeLoader } from "react-spinners";

const PayRollFormModal = ({ show, onClose, initialData, multipleData, onSuccess }) => {
  const dispatch = useDispatch();
  const { addPayRoll } = PayrollViewController();
  const { isLoding } = useSelector((state) => state.payslip);

  const formik = useFormik({
    initialValues: {
      effective_from_date: "",
    },
    validationSchema: Yup.object({
      effective_from_date: Yup.string().required(
        "Effective from date is required"
      ),
    }),
    onSubmit: (values, { resetForm }) => {
      const effectiveDate = values.effective_from_date;

      let employees = [];

      if (initialData) {
        const name = initialData.employee_name || "Unknown";
        employees.push({
          id: initialData.employee_id || initialData.id, // fallback to .id if .employee_id not available
          name,
        });
      } else if (multipleData.length > 0) {
        employees = multipleData.map((emp) => ({
          id: emp.employee_id || emp.id,
          name: emp.employee_name || "Unknown",
        }));
      }

      const payload = {
        employees,
        effective_from_date: effectiveDate,
      };

      dispatch(addPayRoll(payload));
      
      onClose();
      resetForm();
      if (onSuccess) onSuccess();

    },
  });

  return (
    <Dialog open={show} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Payroll</DialogTitle>

      <form onSubmit={formik.handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>Effective From Date *</Typography>
              <TextField
                fullWidth
                type="date"
                name="effective_from_date"
                value={formik.values.effective_from_date}
                onChange={formik.handleChange}
                error={
                  formik.touched.effective_from_date &&
                  Boolean(formik.errors.effective_from_date)
                }
                helperText={
                  formik.touched.effective_from_date &&
                  formik.errors.effective_from_date
                }
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            Submit
          </Button>

        {isLoding && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(255, 255, 255, 0.6)",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "linear-gradient(45deg,rgb(65, 63, 63),rgb(238, 231, 238))",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            <FadeLoader
              // color={"#f27121"} // fallback color, not used with gradient
              loading={true}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        </div>
      )}
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default PayRollFormModal;

// import React, { useEffect } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Button,
//   Grid,
//   Typography,
// } from "@mui/material";
// import * as Yup from "yup";
// import { useFormik } from "formik";
// import { useDispatch, useSelector } from "react-redux";
// import PayrollViewController from "../../redux/actions/payrollApiAction";
// import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";

// const PayRollFormModal = ({ show, onClose }) => {
//   const dispatch = useDispatch();
//   const { getEmployees } = EmployeeProfileVeiwController();
//   const { addPayRoll, getEmployeePayroll } = PayrollViewController();

//   const { employee_data } = useSelector((state) => state.employeeProfile);
//   const { payroll } = useSelector((state) => state.payslip);

//   useEffect(() => {
//     dispatch(getEmployees());
//     dispatch(getEmployeePayroll());
//   }, [dispatch]);

//   const calculateTotalFromObject = (obj) => {
//     return Object.values(obj || {}).reduce(
//       (acc, value) => acc + parseFloat(value || 0),
//       0
//     );
//   };

//   const formik = useFormik({
//     initialValues: {
//       employee: "",
//       basic_salary: "",
//       hra: 0,
//       deductions: {},
//       bonus: 0,
//       other_allowances: {},
//       gross_salary: "",
//       net_salary: "",
//       effective_from_date: "",
//       paid: false,
//     },
//     validationSchema: Yup.object({
//       employee: Yup.string().required("Employee is required"),
//       basic_salary: Yup.number().required("Basic salary is required"),
//     }),
//     onSubmit: (values, { resetForm }) => {
//       dispatch(addPayRoll(values));
//       onClose();
//       resetForm();
//     },
//   });

//   const isAutoFilled = !!formik.values.basic_salary;

//   return (
//     <Dialog open={show} onClose={onClose} fullWidth maxWidth="md">
//       <DialogTitle>Add New Payroll</DialogTitle>
//       <form onSubmit={formik.handleSubmit}>
//         <DialogContent dividers>
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6}>
//               <Typography>Employee *</Typography>
//               <TextField
//                 select
//                 fullWidth
//                 name="employee"
//                 value={formik.values.employee}
//                 onChange={(e) => {
//                   const selectedId = e.target.value;
//                   formik.setFieldValue("employee", selectedId);

//                   const employeePayroll = payroll.find(
//                     (pay) => pay.employee_id.toString() === selectedId
//                   );

//                   if (employeePayroll) {
//                     const totalAllowances = calculateTotalFromObject(employeePayroll.other_allowances);
//                     const totalDeductions = calculateTotalFromObject(employeePayroll.deductions);
//                     formik.setFieldValue("basic_salary", employeePayroll.basic_salary || "");
//                     formik.setFieldValue("deductions", employeePayroll.deductions || {});
//                     formik.setFieldValue("hra", employeePayroll.hra || 0);
//                     formik.setFieldValue("bonus", employeePayroll.bonus || 0);
//                     formik.setFieldValue("other_allowances", employeePayroll.other_allowances || {});
//                     formik.setFieldValue("allowances", totalAllowances);
//                     formik.setFieldValue("net_salary", employeePayroll.net_salary || 0);
//                     formik.setFieldValue("gross_salary", employeePayroll.gross_salary || 0);
//                     formik.setFieldValue("total_deductions", totalDeductions);
//                   } else {
//                     formik.setFieldValue("basic_salary", "");
//                     formik.setFieldValue("deductions", "");
//                     formik.setFieldValue("hra", "");
//                     formik.setFieldValue("bonus", "");
//                     formik.setFieldValue("other_allowances", "");
//                     formik.setFieldValue("allowances", "");
//                     formik.setFieldValue("net_salary", "");
//                     formik.setFieldValue("gross_salary", "");
//                   }
//                 }}
//                 error={formik.touched.employee && Boolean(formik.errors.employee)}
//                 helperText={formik.touched.employee && formik.errors.employee}
//                 SelectProps={{ native: true }}
//               >
//                 <option value="">Select Employee</option>
//                 {employee_data?.employees.map((emp) => (
//                   <option key={emp.id} value={emp.id}>
//                     {emp.first_name} {emp.last_name}
//                   </option>
//                 ))}
//               </TextField>
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <Typography>Basic Salary *</Typography>
//               <TextField
//                 fullWidth
//                 type="number"
//                 name="basic_salary"
//                 value={formik.values.basic_salary}
//                 onChange={formik.handleChange}
//                 error={formik.touched.basic_salary && Boolean(formik.errors.basic_salary)}
//                 helperText={formik.touched.basic_salary && formik.errors.basic_salary}
//                 disabled={isAutoFilled}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <Typography>HRA</Typography>
//               <TextField
//                 fullWidth
//                 type="number"
//                 name="hra"
//                 value={formik.values.hra}
//                 onChange={formik.handleChange}
//                 disabled={isAutoFilled}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <Typography>Bonus</Typography>
//               <TextField
//                 fullWidth
//                 type="number"
//                 name="bonus"
//                 value={formik.values.bonus}
//                 onChange={formik.handleChange}
//                 disabled={isAutoFilled}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <Typography>Deductions</Typography>
//               <TextField
//                 fullWidth
//                 type="number"
//                 name="total_deductions"
//                 value={formik.values.total_deductions}
//                 onChange={formik.handleChange}
//                 disabled={isAutoFilled}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <Typography>Allowances</Typography>
//               <TextField
//                 fullWidth
//                 type="number"
//                 name="allowances"
//                 value={formik.values.allowances}
//                 onChange={formik.handleChange}
//                 disabled={isAutoFilled}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <Typography>Gross Salary</Typography>
//               <TextField
//                 fullWidth
//                 type="number"
//                 name="gross_salary"
//                 value={formik.values.gross_salary}
//                 onChange={formik.handleChange}
//                 disabled={isAutoFilled}
//               />
//             </Grid>

//             <Grid item xs={12} sm={6}>
//               <Typography>Net Salary</Typography>
//               <TextField
//                 fullWidth
//                 type="number"
//                 name="net_salary"
//                 value={formik.values.net_salary}
//                 onChange={formik.handleChange}
//                 disabled={isAutoFilled}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Typography>Effective From Date</Typography>
//               <TextField
//                 fullWidth
//                 type="date"
//                 name="effective_from_date"
//                 value={formik.values.effective_from_date}
//                 onChange={formik.handleChange}
//                 error={formik.touched.effective_from_date && Boolean(formik.errors.effective_from_date)}
//                 helperText={formik.touched.effective_from_date && formik.errors.effective_from_date}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={onClose} color="secondary">
//             Cancel
//           </Button>
//           <Button type="submit" variant="contained">
//             Submit
//           </Button>
//         </DialogActions>
//       </form>
//     </Dialog>
//   );
// };

// export default PayRollFormModal;
